(function() {
    'use strict';

    document.addEventListener('alpine:init', () => {
        Alpine.data('flyout', (id, direction = 'right') => ({
            open: false,
            contentVisible: false,
            overlayVisible: false,
            direction: direction,
            scrollTop: 0,

            $header: null,

            init() {
                this.$header = document.querySelector('.site-header');
            },

            events: {
                ['@flyout-show.window']: function(e) {
                    if (e.detail !== id) {
                        return;
                    }

                    this.show();
                },
                ['@keydown.escape.window']: function() {
                    if (this.open) {
                        this.hide();
                    }
                },
            },

            show() {
                this.primeScrollTopCache();

                document.documentElement.style.setProperty(
                    '--site-scroll-top',
                    `${this.getScrollTop(true)}px`,
                );

                document.documentElement.classList.add('flyout--open');

                this.open = true;
                this.overlayVisible = true;
                this.contentVisible = true;

                setTimeout(() => {
                    const panel = this.$el.querySelector('[tabindex="-1"]');
                    if (panel) {
                        panel.focus();
                    }
                }, 50);
            },

            hide() {
                // Steg 1: Glid ut innehållet först
                this.contentVisible = false;

                // Steg 2: Efter innehållets transition, fada ut overlayen
                setTimeout(() => {
                    this.overlayVisible = false;

                    // Steg 3: Efter overlay-transition, stäng helt
                    setTimeout(() => {
                        document.documentElement.classList.remove('flyout--open');
                        document.documentElement.style.setProperty(
                            '--site-scroll-top',
                            '0px',
                        );
                        document.documentElement.scrollTo(0, this.getScrollTop(true));

                        this.clearScrollTopCache();

                        this.open = false;
                    }, 300);
                }, 300);
            },

            primeScrollTopCache() {
                this.scrollTop = this.getScrollTop();
            },

            clearScrollTopCache() {
                this.scrollTop = 0;
            },

            getScrollTop(cached = false) {
                if (cached) {
                    return this.scrollTop;
                }

                return window.pageYOffset || document.documentElement.scrollTop;
            },
        }));
    });
}());
